'use client';
import RatingStars from '@/components/shared/rating-stars/rating-stars.component';
import Typography from '@/components/shared/typography/typography.component';
import classes from './styles.module.scss';
import moment from 'moment';
import { useTranslation } from '@/hook';

export default function TestimonialItem({
    verbatim,
    name,
    rating,
    reviewDate,
}: {
    verbatim: string;
    name: string;
    rating: number;
    reviewDate: Date | null;
}) {
    const { i18n, IS_RTL } = useTranslation();
    const lang = i18n.language;
    return (
        <div className={classes.testimonialItem} dir={IS_RTL ? 'rtl' : 'ltr'}>
            <div className={classes.reviewContainer}>
                <div className={classes.review}>
                    <Typography variant={'body1Medium'}>{verbatim}</Typography>
                </div>
            </div>
            <div className={classes.attributionContainer}>
                <div className={classes.nameAndDate}>
                    <Typography
                        variant={'body2'}
                        className={classes.name}
                    >{`— ${name}`}</Typography>
                    <Typography variant={'caption'}>
                        {moment(reviewDate).locale(lang).fromNow()}
                    </Typography>
                </div>
                <RatingStars rating={rating} />
            </div>
        </div>
    );
}
